import React from "react";
import { Flame, Users, Award, Sparkles } from "lucide-react";

export default function AboutUs() {
  return (
    <section
      id="o-nas"
      data-testid="about-section"
      className="bg-white border-t border-zinc-200 py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-[var(--feniks-red)] mb-4">
              [01] O nas
            </div>
            <h2 data-testid="about-headline" className="font-display text-3xl md:text-4xl lg:text-5xl leading-none tracking-tighter mb-6">
              Z popiołów do pełnej sprawności.
            </h2>
            <p className="text-zinc-600 text-base leading-relaxed">
              Feniks Gastro AGD to ekipa techników z wieloletnim doświadczeniem w serwisie sprzętu
              gastronomicznego i AGD. Łączymy precyzję, lokalną dostępność i uczciwą wycenę.
            </p>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-px bg-zinc-200">
            {[
              {
                icon: Flame,
                title: "Filozofia Feniksa",
                text: "Wierzymy, że dobrze zaprojektowany sprzęt zasługuje na drugie życie. Naprawiamy zamiast wyrzucać.",
              },
              {
                icon: Users,
                title: "Lokalna obsługa",
                text: "Działamy na Górnym Śląsku i w Zagłębiu — od Katowic po Jaworzno i Tychy. Szybki dojazd to nasz standard.",
              },
              {
                icon: Award,
                title: "Specjalizacja",
                text: "12+ kategorii sprzętu: od pralek i lodówek po wyparzarki, miksery KitchenAid i pakowarki próżniowe.",
              },
              {
                icon: Sparkles,
                title: "Przejrzysta wycena",
                text: "Stała diagnostyka + dokładny cennik usług. Płacisz tylko za to, co naprawdę zostało zrobione.",
              },
            ].map((b, i) => (
              <div
                key={i}
                data-testid={`about-bento-${i}`}
                className="bg-white p-6 md:p-8 hover:bg-zinc-50 transition-colors group"
              >
                <b.icon size={22} className="text-[var(--feniks-red)] mb-4" />
                <h3 className="font-display text-lg tracking-tight mb-2">{b.title}</h3>
                <p className="text-sm text-zinc-600 leading-relaxed">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
